import { render, staticRenderFns } from "./ProductWrhousngStatus.vue?vue&type=template&id=f65e66b6&scoped=true&"
import script from "./ProductWrhousngStatus.vue?vue&type=script&lang=js&"
export * from "./ProductWrhousngStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProductWrhousngStatus.vue?vue&type=style&index=0&id=f65e66b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65e66b6",
  null
  
)

export default component.exports